import { gql } from 'apollo-boost';

export const REQUEST_MESSAGES_EXPORT = gql`
    mutation RequestMessagesExport($data: MessagesExportInput!) {
        requestMessagesExport(data: $data) {
            resultUrl
            expiresAt
            messageCount
            fileCount
        }
    }
`;
